import { ComponentRef, Injectable, Provider } from '@angular/core';
import { IAddressSelectDialogService, IAddressSelectDialogServiceToken } from './address-select-dialog-service.abstract';
import { AddressDto } from 'shared/services/INTEGRA_Shop_Client';
import { DialogBaseService } from '../../dialog.service';
import { AddressSelectDialogComponent } from 'shared/components/shared/address/select-dialog/address-select-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AddressSelectDialogService implements IAddressSelectDialogService {

  addressSelectDialogShow(
    modalTitle: string,
    addressList: AddressDto[],
    callbackSubmit: (result: AddressDto) => void,
    callbackCancel: () => void
  ) {
    DialogBaseService.dialogGenericShow(
      AddressSelectDialogComponent,
      (component: ComponentRef<AddressSelectDialogComponent>) => {
        component.instance.modalTitle = modalTitle;
        component.instance.addressList = addressList;

        component.instance.modalSubmit.subscribe(
          (result: AddressDto) => {
            callbackSubmit(result);
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
        component.instance.modalCancel.subscribe(
          () => {
            callbackCancel();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
      }
    );
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AddressSelectDialogServiceProvider: Provider[] = [
  { provide: IAddressSelectDialogServiceToken, useExisting: AddressSelectDialogService }
];
